<template>
  <div
    class="health-review-card"
    :class="{ 'p-2 border rounded': !compact }"
  >
    <div
      v-if="!compact"
      class="d-flex justify-content-between align-items-center mb-1"
    >
      <b>ทบทวนประวัติสุขภาพ *</b>
      <HealthReviewedLine
        :patient="patient"
        show-days-ago
        class="small-text text-muted"
      />
    </div>

    <div
      v-if="reviewedDt && !editing"
      class="mb-1"
    >
      <span class="text-success">✓ ทบทวนแล้ววันนี้ {{ reviewedTime }}</span>
    </div>

    <div class="d-flex flex-wrap">
      <b-button
        size="sm"
        class="mr-2 mb-1"
        :variant="
          value && value.result === 'NO_CHANGE' ? 'success' : 'outline-success'
        "
        @click="chooseNoChange"
      >
        {{
          reviewedDt
            ? "✓ ไม่มีเปลี่ยนแปลง (ยืนยันอีกครั้ง)"
            : "✓ ไม่มีเปลี่ยนแปลง"
        }}
      </b-button>
      <b-button
        size="sm"
        class="mb-1"
        :variant="editing ? 'warning' : 'outline-warning'"
        :disabled="loading"
        @click="chooseChanged"
      >
        {{ reviewedDt ? "✎ แก้ไขอีกครั้ง" : "✎ มีการเปลี่ยนแปลง — แก้ไข" }}
      </b-button>
    </div>

    <div
      v-if="loading"
      class="mt-2 small-text text-muted"
    >
      <b-spinner
        small
        class="mr-1"
      />กำลังโหลดข้อมูลล่าสุด...
    </div>
    <div
      v-else-if="editing"
      class="mt-2"
    >
      <b-form-group
        label="โรคประจำตัว"
        class="mb-2"
      >
        <HealthListInput
          v-model="draft.congenitalDisease"
          :options="DISEASE_OPTIONS"
          size="sm"
          @input="emitChanged"
        />
      </b-form-group>
      <b-form-group
        label="ประวัติการแพ้ยา"
        class="mb-2"
      >
        <HealthListInput
          v-model="draft.allergic"
          :options="ALLERGY_OPTIONS"
          danger
          size="sm"
          @input="emitChanged"
        />
      </b-form-group>
      <b-form-group
        label="ประวัติการใช้ยา"
        class="mb-2"
      >
        <HealthListInput
          v-model="draft.medicationHistory"
          :options="MEDICATION_OPTIONS"
          size="sm"
          @input="emitChanged"
        />
      </b-form-group>
      <b-form-checkbox
        v-model="draft.antithrombotic"
        class="mb-0"
        @change="emitChanged"
      >
        ใช้ยาต้านเกล็ดเลือด/ละลายลิ่มเลือด
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { editedHealthFields, healthEditDraft } from "@/utils/healthReview";
import {
  DISEASE_OPTIONS,
  ALLERGY_OPTIONS,
  MEDICATION_OPTIONS,
} from "@/constants/healthOptions";
import HealthListInput from "./HealthListInput.vue";
import HealthReviewedLine from "./HealthReviewedLine.vue";

export default {
  name: "HealthReviewCard",
  components: { HealthListInput, HealthReviewedLine },
  props: {
    patient: { type: Object, required: true },
    reviewedDt: { type: [String, Date], default: null },
    value: { type: Object, default: null },
    compact: { type: Boolean, default: false },
  },
  data() {
    return {
      editing: false,
      loading: false,
      snapshot: healthEditDraft(this.patient),
      draft: healthEditDraft(this.patient),
      DISEASE_OPTIONS,
      ALLERGY_OPTIONS,
      MEDICATION_OPTIONS,
    };
  },
  computed: {
    reviewedTime() {
      return moment(this.reviewedDt).format("HH:mm");
    },
  },
  methods: {
    chooseNoChange() {
      this.editing = false;
      this.$emit("input", { result: "NO_CHANGE" });
    },
    async chooseChanged() {
      if (this.loading) return;
      this.loading = true;
      this.editing = true;
      let source = this.patient;
      try {
        const res = await this.$store.dispatch("modulePatient/fetchPatientById", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: this.patient.id,
        });
        if (res && res.data) source = res.data;
      } catch (e) {
        // fall back to the cached patient
      }
      this.snapshot = healthEditDraft(source);
      this.draft = healthEditDraft(source);
      this.loading = false;
      this.emitChanged();
    },
    emitChanged() {
      this.$nextTick(() => {
        const health = editedHealthFields(this.snapshot, this.draft);
        if (!Object.keys(health).length) {
          this.$emit("input", null);
          return;
        }
        this.$emit("input", { result: "CHANGED", health });
      });
    },
  },
};
</script>
